import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import * as types from "../../sdk/types/api";
import { TIngredientCategoryPayload } from "../../sdk/utils/api/ingredients";

export const useCreateIngredientCategory = (
    invalidQueryKeys: string | (string | number)[],
): UseMutationResult<types.IIngredientCategory, unknown, TIngredientCategoryPayload> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<types.IIngredientCategory, unknown, TIngredientCategoryPayload>({
        mutationFn: async (parameters: TIngredientCategoryPayload) => {
            if (!auth.token) {
                throw new Error("Cannot save without authorization token.");
            }
            return await api.Ingredients.createCategory(parameters, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
